(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 8456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircularProgress_CircularProgress; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(4780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(8216);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js + 1 modules
var DefaultPropsProvider = __webpack_require__(5845);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(2591);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(4867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js


function getCircularProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
'use client';



const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,capitalize/* default */.Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,capitalize/* default */.Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,styled/* default */.ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0,styled/* default */.ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    style: (0,esm_extends/* default */.Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);

/***/ }),

/***/ 6008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(5923);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JsonLd; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function JsonLd(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(data)
        }
    });
}


/***/ }),

/***/ 5923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/FormSuccessDialog/FormSuccessDialog.js
var FormSuccessDialog = __webpack_require__(1987);
// EXTERNAL MODULE: ./components/FormErrorDialog/FormErrorDialog.js
var FormErrorDialog = __webpack_require__(299);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./components/TextInput/TextInput.js
var TextInput = __webpack_require__(7902);
// EXTERNAL MODULE: ./components/RadioInput/RadioInput.js
var RadioInput = __webpack_require__(1427);
// EXTERNAL MODULE: ./components/TextInputArea/TextInputArea.js
var TextInputArea = __webpack_require__(3487);
// EXTERNAL MODULE: ./hooks/useReportError.js
var useReportError = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(8456);
// EXTERNAL MODULE: ./constants.js
var constants = __webpack_require__(8148);
// EXTERNAL MODULE: ./utils/recaptcha.js
var recaptcha = __webpack_require__(3575);
// EXTERNAL MODULE: ./components/Recaptcha/RecaptchaModal.js
var RecaptchaModal = __webpack_require__(4559);
;// CONCATENATED MODULE: ./components/ContactForm/ContactFormContactPage.js
















var ContactFormContactPage = function(props) {
    var updateShowSuccess = props.updateShowSuccess, updateShowError = props.updateShowError;
    var ref = (0,react.useState)(""), firstName = ref[0], setFirstName = ref[1];
    var ref1 = (0,react.useState)(""), lastName = ref1[0], setLastName = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), city = ref3[0], setCity = ref3[1];
    var ref4 = (0,react.useState)(""), state = ref4[0], setState = ref4[1];
    var ref5 = (0,react.useState)(""), phoneNumber = ref5[0], setPhoneNumber = ref5[1];
    var ref6 = (0,react.useState)(""), userType = ref6[0], setUserType = ref6[1];
    var ref7 = (0,react.useState)(""), message = ref7[0], setMessage = ref7[1];
    var ref8 = (0,react.useState)(""), messageError = ref8[0], setMessageError = ref8[1];
    var reportError = (0,useReportError/* default */.Z)().reportError;
    var ref9 = (0,react.useState)(false), stateFocus = ref9[0], setStateFocus = ref9[1];
    var ref10 = (0,react.useState)(false), isSubmitting = ref10[0], setIsSubmitting = ref10[1];
    var ref11 = (0,react.useState)(false), disabledField = ref11[0], setDisabledField = ref11[1];
    var ref12 = (0,react.useState)(false), showCheckboxFallback = ref12[0], setShowCheckboxFallback = ref12[1];
    var ref13 = (0,react.useState)(null), pendingSubmitData = ref13[0], setPendingSubmitData = ref13[1];
    var FormProcess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var token, err, payload, doSubmit, response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!message.trim()) {
                            setMessageError("Message is required");
                            return [
                                2
                            ];
                        }
                        setMessageError("");
                        setDisabledField(true);
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,recaptcha/* getRecaptchaV3Token */.o)("contact_page")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("[recaptcha] v3 token generation failed", err);
                        updateShowError(true);
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                    case 4:
                        payload = {
                            first_name: firstName,
                            last_name: lastName,
                            email_address: email,
                            who_are_you: userType,
                            city: city,
                            state: state,
                            phone_number: phoneNumber,
                            message: message,
                            captcha_token: {
                                token: token,
                                version: "v3",
                                provider: 1
                            }
                        };
                        doSubmit = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    // normal submit
                                    return [
                                        2,
                                        fetch("".concat(constants/* BASE_URL */._, "/Marketing/ContactUs"), {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify(body)
                                        })
                                    ];
                                });
                            });
                            return function doSubmit(body) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        response = null;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            doSubmit(payload)
                        ];
                    case 6:
                        response = _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        return [
                            4,
                            reportError(error)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 9:
                        if (response && response.status === 400) {
                            // server requests v2 checkbox fallback
                            setPendingSubmitData(payload);
                            setShowCheckboxFallback(true);
                            setDisabledField(false);
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        if (!(response && (response === null || response === void 0 ? void 0 : response.status))) return [
                            3,
                            12
                        ];
                        if (!(response.status < 200 || response.status > 299)) return [
                            3,
                            11
                        ];
                        updateShowError(true);
                        return [
                            4,
                            reportError(response)
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        updateShowSuccess(true);
                        _state.label = 12;
                    case 12:
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function FormProcess(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCheckboxVerify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(token) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // v2 token received
                        if (!pendingSubmitData) return [
                            2
                        ];
                        setShowCheckboxFallback(false);
                        setDisabledField(true);
                        setIsSubmitting(true);
                        return [
                            4,
                            fetch("".concat(constants/* BASE_URL */._, "/Marketing/ContactUs"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pendingSubmitData), {
                                    captcha_token: {
                                        token: token,
                                        version: "v2",
                                        provider: 1
                                    }
                                }))
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        setPendingSubmitData(null);
                        if (response.status >= 200 && response.status <= 299) {
                            updateShowSuccess(true);
                        } else {
                            updateShowError(true);
                        }
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckboxVerify(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDelayedBlur = function() {
        setTimeout(function() {
            setStateFocus(false);
        }, 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-screen-xl mx-auto ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "recaptcha-container-invisible",
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: FormProcess,
                        className: "grid grid-cols-1 md:grid-cols-2 text-grey",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    required: true,
                                    type: "text",
                                    minLength: 2,
                                    maxLength: 20,
                                    disabled: disabledField,
                                    value: firstName,
                                    change: function(e) {
                                        setFirstName(e.target.value);
                                    },
                                    children: "First Name"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    required: true,
                                    type: "text",
                                    minLength: 2,
                                    maxLength: 20,
                                    disabled: disabledField,
                                    value: lastName,
                                    change: function(e) {
                                        setLastName(e.target.value);
                                    },
                                    children: "Last Name"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 md:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    required: true,
                                    type: "email",
                                    minLength: 2,
                                    maxLength: 60,
                                    disabled: disabledField,
                                    value: email,
                                    change: function(e) {
                                        setEmail(e.target.value);
                                    },
                                    children: "Email"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 md:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                    required: true,
                                    type: "tel",
                                    minLength: 2,
                                    maxLength: 20,
                                    disabled: disabledField,
                                    value: phoneNumber,
                                    change: function(e) {
                                        setPhoneNumber(e.target.value);
                                    },
                                    children: "Phone Number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-1 md:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        required: true,
                                        minLength: 2,
                                        maxLength: 20,
                                        disabled: disabledField,
                                        value: city,
                                        change: function(e) {
                                            setCity(e.target.value);
                                        },
                                        children: "City"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative pt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                                required: true,
                                                minLength: 2,
                                                maxLength: 20,
                                                disabled: disabledField,
                                                value: state,
                                                change: function(e) {
                                                    setState(e.target.value);
                                                },
                                                onBlurCustom: function() {
                                                    return handleDelayedBlur();
                                                },
                                                onFocusCustom: function() {
                                                    return setStateFocus(true);
                                                },
                                                children: "State"
                                            }),
                                            stateFocus && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-[105%] right-0 flex flex-col gap-2 h-[400px] w-[95%] overflow-y-scroll bg-white-light z-10 shadow-md py-2",
                                                children: STATES.map(function(state, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        value: state,
                                                        className: "p-2 px-4 cursor-pointer hover:bg-blue-light/20",
                                                        onClick: function() {
                                                            return setState(state);
                                                        },
                                                        children: state
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 md:col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "border-1 border-solid border-white mx-1.5 my-2 md:m-3.5 pb-4 bg-white-light",
                                    role: "group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "mx-5 my-5 text-xl text-darkGray",
                                            children: "Who are you? *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput/* default */.Z, {
                                            required: true,
                                            name: "userType",
                                            value: "employer",
                                            selectedValue: userType,
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Employer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput/* default */.Z, {
                                            required: true,
                                            name: "userType",
                                            value: "individual",
                                            selectedValue: userType,
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Individual"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput/* default */.Z, {
                                            required: true,
                                            name: "userType",
                                            value: "broker",
                                            selectedValue: userType,
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Broker"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 md:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputArea/* default */.Z, {
                                    required: true,
                                    disabled: disabledField,
                                    minLength: 10,
                                    maxLength: 2000,
                                    value: message,
                                    error: messageError,
                                    change: function(e) {
                                        setMessage(e.target.value);
                                        if (messageError) setMessageError("");
                                    },
                                    children: "Message"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-1 mx-auto mt-8 md:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "submit",
                                    className: "flex items-center gap-2 px-12 py-2 text-2xl bg-blue text-white-light",
                                    children: [
                                        isSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                            size: "1.5rem"
                                        }),
                                        "Send"
                                    ]
                                })
                            })
                        ]
                    }),
                    showCheckboxFallback && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "fixed",
                            inset: 0,
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: "rgba(0,0,0,0.5)",
                                    position: "absolute",
                                    inset: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    zIndex: 10000,
                                    background: "#fff",
                                    padding: 20,
                                    borderRadius: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: "Please complete the verification to continue"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaModal/* default */.Z, {
                                        onVerify: function(token) {
                                            return handleCheckboxVerify(token);
                                        },
                                        onError: function() {
                                            setShowCheckboxFallback(false);
                                            updateShowError(true);
                                        },
                                        onClose: function() {
                                            return setShowCheckboxFallback(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            marginTop: 8,
                                            textAlign: "right"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "px-4 py-2 text-sm",
                                            onClick: function() {
                                                setShowCheckboxFallback(false);
                                            },
                                            children: "Cancel"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var STATES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY", 
];
/* harmony default export */ var ContactForm_ContactFormContactPage = (ContactFormContactPage);

// EXTERNAL MODULE: ./components/SEO/JsonLd.js
var JsonLd = __webpack_require__(3154);
// EXTERNAL MODULE: ./components/SEO/SEO.js + 1 modules
var SEO = __webpack_require__(3976);
// EXTERNAL MODULE: ./layout/Layout.js + 6 modules
var Layout = __webpack_require__(9875);
// EXTERNAL MODULE: ./styles/section.module.css
var section_module = __webpack_require__(3538);
var section_module_default = /*#__PURE__*/__webpack_require__.n(section_module);
// EXTERNAL MODULE: ./hooks/useRecaptchaLoader.js
var useRecaptchaLoader = __webpack_require__(2219);
;// CONCATENATED MODULE: ./pages/contact-us.js











var ContactUs = function() {
    var ref = (0,react.useState)(false), showSuccess = ref[0], setShowSuccess = ref[1];
    var ref1 = (0,react.useState)(false), showError = ref1[0], setshowError = ref1[1];
    var toggleModal = function() {
        setshowError(false);
        setShowSuccess(false);
    };
    // Wrap the setters so we can log when they are toggled from child components
    var updateShowSuccess = function(value) {
        setShowSuccess(value);
    };
    var updateShowError = function(value) {
        setshowError(value);
    };
    // load recaptcha script on pages that need it
    var ref2 = (0,useRecaptchaLoader/* default */.Z)(), recaptchaLoaded = ref2.loaded, recaptchaError = ref2.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                    data: {
                        "@context": "https://schema.org",
                        "@type": "ContactPage",
                        name: "Contact Evry Health",
                        url: "https://www.evryhealth.com/contact-us",
                        mainEntity: {
                            "@type": "Organization",
                            name: "Evry Health",
                            telephone: "+1-855-579-3879",
                            email: "support@evryhealth.com",
                            address: {
                                "@type": "PostalAddress",
                                addressLocality: "Dallas",
                                addressRegion: "TX",
                                addressCountry: "US"
                            }
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                pageTitle: "Evry Health - Better Health Insurance",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "dfwSkyline.png",
                                                alt: "Dallas-Fort Worth skyline"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-3xl tracking-tight md:text-5xl text-darkBlue",
                                                    children: "Contact Us"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "max-w-lg mt-6 text-xl text-grey sm:max-w-3xl",
                                                    children: "We're here to answer all your questions."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-screen-xl px-6 py-12 mx-auto md:px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:grid lg:grid-cols-2 lg:gap-8",
                                children: [
                                    showSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessDialog/* default */.Z, {
                                        click: function(e) {
                                            setShowSuccess(false);
                                        },
                                        toggleModal: toggleModal
                                    }),
                                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorDialog/* default */.Z, {
                                        click: function(e) {
                                            setshowError(false);
                                        },
                                        toggleModal: toggleModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm_ContactFormContactPage, {
                                            updateShowSuccess: updateShowSuccess,
                                            updateShowError: updateShowError
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:col-span-1 pl-0 ".concat((section_module_default()).transformDFWMap, " mt-8"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "dfw-map.png",
                                                alt: "Map of DFW"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "pt-16 text-lg text-grey",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                        className: "pb-8 text-3xl leading-10 md:text-4xl text-blue-dark",
                                                        children: [
                                                            "Headquartered in DFW and ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "inline-block py-2",
                                                                children: "serving the state of Texas."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "inline-block py-2 text-globeGreen",
                                                                children: "We're from here!"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "pb-4 text-xl",
                                                        children: [
                                                            "Call us:",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:1-855-579-3879",
                                                                className: "font-bold",
                                                                children: "1-855-579-3879"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-xl",
                                                        children: [
                                                            "Email us:",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:contact@evryhealth.com",
                                                                className: "font-bold",
                                                                children: "contact@evryhealth.com"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact_us = (ContactUs);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,991,842,774,888,179], function() { return __webpack_exec__(6008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);